module.exports = __webpack_public_path__ + "static/media/eyeflow_logo_R.9ffab7a9.png";